const carouselItems = [
  {
    title: '2026 暑期档必看神剧',
    desc: '盘点本季最值得追的十部高分剧集，从古装到科幻一网打尽',
    image: 'https://readdy.ai/api/search-image?query=Warm%20orange%20cinematic%20summer%20drama%20collection%20visual%20with%20soft%20glowing%20lights%20and%20film%20strip%20elements%2C%20elegant%20minimalist%20poster%20style%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20artistic%20rendering%20with%20subtle%20texture&width=600&height=340&seq=juzi-carousel-01&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '古装大戏年度盘点',
    desc: '2026 年最受瞩目的十部古装巨制，服化道与剧情全面升级',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20aesthetic%20with%20warm%20orange%20and%20gold%20tones%2C%20elegant%20silk%20textures%2C%20traditional%20lanterns%2C%20cinematic%20lighting%2C%20minimalist%20composition%2C%20soft%20atmospheric%20glow%2C%20artistic%20photography%20style&width=600&height=340&seq=juzi-carousel-02&orientation=landscape',
    tag: '古装专题',
  },
  {
    title: '悬疑烧脑剧单推荐',
    desc: '高能反转不断，一口气追完不费劲的烧脑好剧推荐合集',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20and%20suspense%20thriller%20atmosphere%20with%20warm%20amber%20lighting%2C%20shadow%20patterns%2C%20abstract%20geometric%20compositions%2C%20dark%20refined%20mood%2C%20cinematic%20noir%20aesthetic%2C%20elegant%20minimalist%20design&width=600&height=340&seq=juzi-carousel-03&orientation=landscape',
    tag: '悬疑剧场',
  },
  {
    title: '韩剧热播合集',
    desc: '最新最热韩剧一网打尽，从浪漫爱情到社会现实全收录',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20atmosphere%20with%20warm%20sunset%20lighting%2C%20soft%20bokeh%20effect%2C%20elegant%20modern%20aesthetic%2C%20gentle%20golden%20and%20orange%20tones%2C%20cinematic%20composition%2C%20film%20poster%20style&width=600&height=340&seq=juzi-carousel-04&orientation=landscape',
    tag: '韩剧精选',
  },
  {
    title: '经典高分美剧回顾',
    desc: 'IMDB 高分美剧经典重温，每一部都是里程碑级别的存在',
    image: 'https://readdy.ai/api/search-image?query=Classic%20American%20TV%20drama%20cinematic%20atmosphere%2C%20warm%20vintage%20lighting%2C%20film%20reel%20and%20clapperboard%20elements%2C%20elegant%20golden%20age%20Hollywood%20aesthetic%2C%20soft%20texture%2C%20artistic%20rendering&width=600&height=340&seq=juzi-carousel-05&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '治愈系日剧合集',
    desc: '温暖人心的日剧精选，从美食到生活哲学感受日式温柔',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20warm%20healing%20atmosphere%20with%20soft%20natural%20light%2C%20minimalist%20interior%20design%2C%20gentle%20orange%20and%20cream%20tones%2C%20cozy%20vibe%2C%20subtle%20cherry%20blossom%20motif%2C%20cinematic%20photography%20style&width=600&height=340&seq=juzi-carousel-06&orientation=landscape',
    tag: '日剧治愈',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-focus-3-line text-sm w-4 h-4 flex items-center justify-center"></i>
            焦点专题
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选专题合集</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">编辑团队精心策划的各类剧集专题，帮您快速找到想看的类型好剧。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div key={item.title} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 text-[11px] font-semibold backdrop-blur-sm whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}